import { Box } from '@bechtel/gds';
import styled from 'styled-components';
import { TertiaryButtonStyled } from '~/styles';

export const ReturnDetailItemStyled = styled.div`
  width: 100%;
`;

export const ReturnDetailItemHoverStyled = styled(Box)`
  &:hover {
    background-color: ${({ theme }) => theme.colors.blue[100]};
  }
`;

export const TertiaryButtonWrapperStyled = styled(TertiaryButtonStyled)`
  background-color: ${({ theme }) => theme.colors.blue[100]};
  color: ${({ theme }) => theme.colors.grey[500]};
`;
